import { useTranslation } from 'react-i18next'

import { Checkbox } from '@reveni-io/reveni-ui'

import { preferences } from '@/configuration/pages/ConfigurationPage/constants'
import { exchangeOrdersAutomaticCreationValues } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/constants'
import { allowedExchangeMethodsIncludesSomeVariantsType } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/ReturnPolicyConfiguration/helpers'
import { providers } from '@/returns/constants'

const ExchangeSendProviderNotificationCheckbox = ({
  checked,
  onChange,
  allowedPreferences,
  exchangeOrdersAutomaticCreation,
  allowedExchangeMethods,
  provider,
  disabled,
}) => {
  const { t } = useTranslation()

  if (
    !allowedPreferences.includes(preferences.allowedExchangeMethods) ||
    !allowedPreferences.includes(preferences.exchangeOrdersAutomaticCreation) ||
    exchangeOrdersAutomaticCreation !== exchangeOrdersAutomaticCreationValues.automatic ||
    !allowedExchangeMethodsIncludesSomeVariantsType(allowedExchangeMethods) ||
    !allowedPreferences.includes(preferences.exchangeOrdersSendProviderNotification) ||
    provider !== providers.shopify
  ) {
    return null
  }

  return (
    <Checkbox
      label={t('Permitir que Shopify envíe email de confirmación del nuevo pedido')}
      checked={checked}
      onChange={e => onChange(e.target.checked)}
      disabled={disabled}
    />
  )
}

export default ExchangeSendProviderNotificationCheckbox
